import React, { Component } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./common/assets/scss/style.scss";
import NavbarWrapper from "./developers/views/components/navbar_wrapper.jsx";

// Developers Routing
// import Marketplace from "./developers/modules/api_marketplace_module/views/marketplace";
// import Billing from "./developers/modules/billing_module/views/billingPage";
// import Keys from "./developers/modules/keys_module/views/keysPage";
import ProjectPage from "./developers/views/project/developer_project_page.jsx";
// import Subscription from "./developers/modules/subscription_module/views/subscriptionPage.jsx";

import CreateProject from "./developers/views/project/components/create_developer_project.jsx";
import ProjectDetailsBloc from "./developers/views/project/blocs/developer_project_details_bloc.jsx";
import PricingPlanPage from "./developers/views/plans/pricing_plan_page.jsx";
// import SubscriptionUsage from "./developers/modules/subscription_module/views/subscriptionUsage.jsx";

// import CreateConfigurationBilling from "./developers/modules/configurations_module/billing_config_module/components/createBilling";
// import BillingsPage from "./developers/modules/configurations_module/billing_config_module/views/billingsPage";
// import CreateConfigurationProject from "./developers/modules/configurations_module/projects_moduile/components/createProject";
// import ProjectsPage from "./developers/modules/configurations_module/projects_moduile/views/projectsPage";
// import CreateConfigurationSubscription from "./developers/modules/configurations_module/subscription_module/components/createSubscription";
// import SubscriptionPage from "./developers/modules/subscription_module/views/subscriptionPage.jsx";
import DeveloperCertificationPage from "./developers/views/certification/developer_certification_page.jsx";
import AdminLoginPage from "./developers/views/login/admin_login_page.jsx";
import DeveloperLoginPage from "./developers/views/login/developer_login_page.jsx";
import CreateSandboxProjectModal from "./developers/views/sandbox/components/create_sandbox_project_modal.jsx";
import SandboxProjectDetailsBloc from "./developers/views/sandbox/blocs/sandbox_project_details_bloc.jsx";
import HomePage from "./developers/views/sandbox/developer_home_page.jsx";
import RoleAccessPage from "./developers/views/configuration/roles/role_access_page.jsx";
import CreateRoleAccessModal from "./developers/views/configuration/roles/components/create_role_access_modal.jsx";
import NavigationAccessPage from "./developers/views/configuration/navigation/navigation_access_page.jsx";
import CreateNavigationAccessModal from "./developers/views/configuration/navigation/components/create_navigation_access_modal.jsx";
import PortfolioPage from "./developers/views/portfolios/portfolio_page.jsx";
import NoAccess from "./developers/views/error/no_access_page.jsx";
import { userRoutes } from "./developers/views/components/navbar_context.jsx";
import { DevPrivateRoute } from "./protectedRoute.jsx";
import HmacSimulatorPage from "./developers/views/resources/simulators/hmac_simulator_page.jsx";
import PaymentPage from "./developers/views/payment/payment_page.jsx";
import TxnNetsSuccessStatusPage from "./developers/views/payment/txn_nets_success_status_page.jsx";
import TxnNetsFailStatusPage from "./developers/views/payment/txn_nets_fail_status_page.jsx";
import InvoicePage from "./developers/views/invoice/invoice_page.jsx";
import InvoiceDetailsPage from "./developers/modules/subscription_module/invoices_module/components/production/views/invoicesDetailsPage.jsx";
import CourseworkPage from "./developers/views/resources/downloads/coursework_page.jsx";
import GetStartedPage from "./developers/views/start/get_started_page.jsx";
import CertificationJourneyPage from "./developers/views/journey/certification_journey_page.jsx";
import SandboxNetsCertificationPage from "./developers/views/journey/sandbox_nets_coursework_page.jsx";
import ProjectCertificationOptionPage from "./developers/views/journey/project_certification_option_page.jsx";
import StagingNetsCourseworkPage from "./developers/views/journey/staging_nets_coursework_page.jsx";
import DeveloperPrivacyPage from "./developers/views/policy/developer_privacy_page.jsx";
import BuildingBlockPage from "./developers/views/journey/building_block_page.jsx";
import PolyFinTechPage from "./developers/views/polyfintech/polyfintech_page.jsx";
import SkillsDevelopmentPage from "./developers/views/polyfintech/skills_development_page.jsx"
import CompetitionPage from "./developers/views/polyfintech/competition_page.jsx"
import NetsQrIdeationPage from "./developers/views/polyfintech/nets_qr_ideation_page.jsx"
import ENetsIdeationPage from "./developers/views/polyfintech/enets_ideation_page.jsx"
import NetsClickIdeationPage from "./developers/views/polyfintech/nets_click_ideation_page.jsx"
import TermsAndConditionsPage from "./developers/views/login/terms_and_conditions_page.jsx";
// import PolyFinTechCertificationPage from "./developers/modules/journey_module/views/polyFinTechCertificationPage.jsx";
import AdminCertificationPage from "./developers/views/administration/certification/admin_certification_page.jsx";
import ProjectReleasePage from "./developers/views/administration/projects/project_release_page.jsx";
import CertificateTemplatePage from "./developers/views/configuration/templates/certificate_template_page.jsx";
import AdministratorPage from "./developers/views/configuration/administrators/administrator_page.jsx";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

//Pages
const Landing = React.lazy(() => import("./foundation/views/home/foundation_home_page.js"));
const PrivacyPolicy = React.lazy(() =>
  import("./foundation/views/policy/foundation_privacy_page.js")
);

const routeComponents = {
  "/homepage": HomePage,
  "/projects": ProjectPage,
  // "/access-roles": RoleAccessPage,
  // "/access-pages": NavigationAccessPage,
  "administration/certification": AdminCertificationPage,
  "/portfolio": PortfolioPage,
  // "/subscriptions/pricing-plan": PricingPlanPage,
  // "/subscriptions/certification": DeveloperCertificationPage,
  "/pricing-plans": PricingPlanPage,
  "/certification": DeveloperCertificationPage,
  "/invoices": InvoicePage,
  "/resources/hmac-simulator": HmacSimulatorPage,
  "/resources/downloads": CourseworkPage,
  // "/certification-journey": CertificationJourneyPage,
  // "/certification/sandbox": SandboxNetsCertificationPage,
  // "/certification/staging": ProjectCertificationOptionPage,
  // "/certification/staging/coursework": StagingNetsCourseworkPage,
  // "/certification/buildingblock": BuildingBlockPage,
  // "/certification/polyfintech": PolyFinTechCertificationPage,
  // "/get-started": GetStartedPage,
  // "/privacy-policy": DeveloperPrivacyPage,
  "administration/projects" : ProjectReleasePage,
  "/configuration/certificate-templates" : CertificateTemplatePage,
  "/configuration/navigation-access": NavigationAccessPage,
  "/configuration/role-access": RoleAccessPage,
  "/configuration/administrators": AdministratorPage,
};

const dynamicRoutes = [
  {
    parent: "/homepage",
    child: {
      "/sandbox/details": SandboxProjectDetailsBloc,
      "/sandbox/create": CreateSandboxProjectModal,
    },
  },
  {
    parent: "/projects",
    child: {
      "/projects/details": ProjectDetailsBloc,
      "/projects/create": CreateProject,
    },
  },
  {
    parent: "/invoices",
    child: {
      // "/subscriptions/pricing-plan": PricingPlanPage,
      // "/subscriptions/certification": DeveloperCertificationPage,
      // "/invoices": InvoicePage,
      "/invoices/details": InvoiceDetailsPage,
    },
  },
];

//DEVELOPERS CONSOLE
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subDomain: null,
      load: true,
    };
  }

  componentDidMount() {
    if (this.state.load) {
      const hostname = window.location.hostname;
      let domain;
      // Find & remove protocol (http, ftp, etc.) and get domain
      if (hostname.indexOf("://") > -1) {
        domain = hostname.split("/")[2];
      } else {
        domain = hostname.split("/")[0];
      }
      // Find & remove port number
      domain = domain.split(":")[0];
      const parts = domain.split(".");
      this.setState({ subDomain: parts[0], load: false });
    }
  }

  render() {
    document.title = "OpenApiPass";
    const { subDomain, load } = this.state;
    let readArr = []; // array just to hold routes across the logic flow
    let transformedChildRoutes = []; // array containing child routes that will be rendered after checking their parents

    const findKeyByValue = (object, value) => {
      // console.log("Object: ", object, "Value: ", value)
      return Object.keys(object).find((key) => object[key] === value);
    };

    if (!load) {
      if (subDomain === "developers") {
        return (
          <div className="App">
            <BrowserRouter>
              <Routes>
                {/* Login */}
                <Route index element={<DeveloperLoginPage />} />
                <Route
                  restricted={false}
                  path="/login/admin"
                  name="Login Page"
                  element={<AdminLoginPage />}
                />
                <Route
                  restricted={false}
                  path="/login/developer"
                  name="Login Page"
                  element={<DeveloperLoginPage />}
                />

            {/* Public routes that don't require authentication */}
            <Route path="/get-started" element={<GetStartedPage />} />
            <Route path="/certification-journey" element={<CertificationJourneyPage />} />
            <Route path="/certification-journey/sandbox" element={<SandboxNetsCertificationPage />} />
            <Route path="/certification-journey/staging" element={<ProjectCertificationOptionPage />} />
            <Route path="/certification-journey/staging/coursework" element={<StagingNetsCourseworkPage />} />
            <Route path="/certification-journey/building-block" element={<BuildingBlockPage />} />
            {/* <Route path="/certification-journey/polyfintech" element={<PolyFinTechCertificationPage />} /> */}
            <Route path="/privacy-policy" element={<DeveloperPrivacyPage />} />
            <Route path="/polyfintech" element={<PolyFinTechPage />} />
            <Route path="/skills-development" element={<SkillsDevelopmentPage />} />
            <Route path="/competition" element={<CompetitionPage />} />
            <Route path="/competition/nets-qr" element={<NetsQrIdeationPage />} />
            <Route path="/competition/enets" element={<ENetsIdeationPage />} />
            <Route path="/competition/nets-click" element={<NetsClickIdeationPage />} />
            

                {/* Portfolios */}
                {/* <Route
                  restricted={false}
                  path="/portfolios"
                  name="Portfolios Page"
                  element={<PortfolioPage />}
                /> */}

                {/* <Route path="/" element={<NavbarWrapper />}> */}
                <Route path="*" element={<NoAccess />} />
                <Route
                  path="/"
                  element={
                    <DevPrivateRoute>
                      <NavbarWrapper />
                    </DevPrivateRoute>
                  }
                >
                  <Route path="/payments" element={<PaymentPage />} />
                  <Route path="/success" element={<TxnNetsSuccessStatusPage />} />
                  <Route path="/fail" element={<TxnNetsFailStatusPage />} />
                  <Route path="/terms-and-condition" element={<TermsAndConditionsPage />} />
                  <Route path="/certification" element={<DeveloperCertificationPage />} />
                  {userRoutes.map((route) => {
                    if (route.subNav) {
                      route.subNav.map((subnav) => {
                        readArr.push(routeComponents[subnav.path]);
                      });
                    } else {
                      readArr.push(routeComponents[route.path]);
                    }
                  })}
                  {/* Render parent routes first */}
                  {readArr.map((Component, idx) => {
                    return (
                      <Route
                        key={`parent-route-${idx}`}
                        path={findKeyByValue(routeComponents, Component)}
                        element={<Component />}
                      />
                    );
                  })}
                  {/* Find child routes after */}
                  {dynamicRoutes.map((a) => {
                    // console.log('parent route:', a.parent);
                    readArr.map((b) => {
                      if (a.parent === findKeyByValue(routeComponents, b)) {
                        // console.log('child routes:', a.child);
                        for (const [path, Component] of Object.entries(
                          a.child
                        )) {
                          transformedChildRoutes.push({
                            path: path,
                            element: Component,
                          });
                        }
                      }
                    });
                  })}
                  {/* Render child routes in transformed arr */}
                  {transformedChildRoutes.map((data, idx) => {
                    const Component = data.element;
                    return <Route key={`child-route-${idx}`} path={data.path} element={<Component />} />;
                  })}
                  {/* <Route path="/developer" element={<NavbarWrapper />}> */}

                  {/* Admin portal routing */}
                  {/* <Route path="/projects" element={<ProjectPage />} />
                  <Route path="/developer/keys" element={<Keys />} />
                  <Route
                    path="/developer/marketplace"
                    element={<Marketplace />}
                  />
                  <Route path="/developer/billing" element={<Billing />} />
                  <Route
                    path="/developer/subscription"
                    element={<Subscription />}
                  /> */}
                  {/* Admin portal sub pages routing */}
                  {/* <Route
                    path="/projects/details"
                    element={<ProjectDetailsBloc />}
                  />
                  <Route path="/projects/create" element={<CreateProject />} />
                  <Route path="/developer/pricing" element={<PricingPlan />} />
                  <Route
                    path="/developer/subscription/usage"
                    element={<SubscriptionUsage />}
                  /> */}

                  {/* Admin portal configurations routing */}
                  {/* <Route
                    path="/resource-groups/configurations/projects"
                    element={<ProjectsPage />}
                  />
                  <Route
                    path="/resource-groups/configurations/projects/create"
                    element={<CreateConfigurationProject />}
                  />
                  <Route
                    path="/resource-groups/configurations/billings"
                    element={<BillingsPage />}
                  />
                  <Route
                    path="/resource-groups/configurations/billings/create"
                    element={<CreateConfigurationBilling />}
                  />
                  <Route
                    path="/resource-groups/configurations/subscriptions"
                    element={<SubscriptionPage />}
                  />
                  <Route
                    path="/resource-groups/configurations/subscriptions/create"
                    element={<CreateConfigurationSubscription />}
                  /> */}
                </Route>
              </Routes>
            </BrowserRouter>
          </div>
        );
      } else {
        return (
          <>
            <BrowserRouter>
              <React.Suspense fallback={loading}>
                <Routes>
                  <Route
                    exact
                    path="/"
                    name="Landing Page"
                    element={<Landing />}
                  />
                  <Route
                    exact
                    path="/policy/privacy"
                    name="Privacy Policy Page"
                    element={<PrivacyPolicy />}
                  />
                </Routes>      
              </React.Suspense>
            </BrowserRouter>
          </>
        );
      }
    }
  }
}

export default App;
